// Écran 2 — la notification Système, ouverte depuis le Web Push de la séance.
// « Accepter » démarre le chrono qui donnera la durée de la séance.

import { useState } from 'react';

import type { PropsEcran } from '../App';
import { Fenetre, Pastille } from '../components';
import { jourCourt, jourLong } from '../lib/format';
import { type EtatQuete, chargerQuete, nouvelleQuete, sauverQuete } from '../lib/quete';
import { VOCAB } from '../lib/theme';

export function Notification({ etat }: PropsEcran) {
  const s = etat.seance;
  const [quete, setQuete] = useState<EtatQuete | null>(() => chargerQuete(s));
  const nom = s ? `Séance ${s.lettre} — ${s.seance.titre}` : '';

  const accepter = (version: 'complete' | 'courte') => {
    if (!s) return;
    const q = nouvelleQuete(s, version, Date.now());
    sauverQuete(q);
    setQuete(q);
  };
  const annuler = () => {
    sauverQuete(null);
    setQuete(null);
  };

  let contenu;
  if (!s) {
    contenu = (
      <>
        <p className="message">[Aucune séance au programme aujourd'hui.]</p>
        <p className="message muted" style={{ fontSize: 14 }}>Les quêtes quotidiennes (tapis, école à pied) t'attendent sur le brief.</p>
        <a className="btn large principal" href="#/" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>RETOUR AU BRIEF</a>
      </>
    );
  } else if (s.faite) {
    contenu = (
      <>
        <p className="message">[Quête accomplie : <strong>{nom}</strong>.]</p>
        <p className="message muted" style={{ fontSize: 14 }}>{s.faite.duree} · {s.faite.ressenti}</p>
        <a className="btn large" href="#/statut" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>VOIR LE STATUT</a>
      </>
    );
  } else if (quete) {
    contenu = (
      <>
        <p className="message">[Quête acceptée : <strong>{quete.version === 'courte' ? `${nom} (12 min)` : nom}</strong>.]</p>
        <p className="message" style={{ fontSize: 14, color: 'var(--sys-text-2)' }}>Une séance courte faite vaut mieux qu'une séance parfaite remise à demain.</p>
        <a className="btn large principal" href="#/quete" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>VOIR LES OBJECTIFS</a>
        <button className="btn fantome" onClick={annuler}>Annuler</button>
      </>
    );
  } else {
    contenu = (
      <>
        <p className="message" style={{ fontSize: 16 }}>
          [{s.repli ? 'Quête en attente' : VOCAB.queteQuotidienne} : <strong>{nom}</strong> {s.repli ? 'attend encore' : 'est arrivée'}.]
        </p>
        <div className="cles">
          <div><span>Créneau</span><span>{s.repli ? `${jourCourt(s.date)} · rattrapage` : `${s.heure} · ${jourLong(s.date)}`}</span></div>
          <div><span>Durée</span><span>≈ {s.seance.duree_min} min</span></div>
          <div><span>Repli</span><span>{etat.versionCourte?.dureeMin ?? 12} min · compte</span></div>
        </div>
        <p className="message">Accepter la quête ?</p>
        <div className="boutons" style={{ width: '100%' }}>
          <button className="btn principal" style={{ minHeight: 48 }} onClick={() => accepter('complete')}>{VOCAB.accepter}</button>
          <button className="btn" style={{ minHeight: 48 }} onClick={() => accepter('courte')}>Version 12 min</button>
        </div>
      </>
    );
  }

  return (
    <main className="ecran centre">
      <div className="grille-fond" />
      <Fenetre equerres className="notification">
        <div className="pastille-ligne">
          <span className="exclam" style={{ width: 30, height: 30, fontSize: 17 }}>!</span>
          <Pastille>{VOCAB.notification}</Pastille>
        </div>
        {contenu}
      </Fenetre>
      <p className="mono" style={{ textAlign: 'center', fontSize: 11, color: 'var(--sys-faint)', letterSpacing: 1, position: 'relative' }}>
        <a href="#/" style={{ color: 'inherit' }}>← BRIEF</a>
      </p>
    </main>
  );
}
